import { render, staticRenderFns } from "./r-rarity-items.vue?vue&type=template&id=6c508f1c"
import script from "./r-rarity-items.vue?vue&type=script&lang=js"
export * from "./r-rarity-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c508f1c')) {
      api.createRecord('6c508f1c', component.options)
    } else {
      api.reload('6c508f1c', component.options)
    }
    module.hot.accept("./r-rarity-items.vue?vue&type=template&id=6c508f1c", function () {
      api.rerender('6c508f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/rarity/r-rarity-items.vue"
export default component.exports